import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=449631f3&scoped=true&lang=pug"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=449631f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449631f3",
  null
  
)

export default component.exports